(function () {
  var STORAGE_KEY = 'collection-filters-open';
  var filterOpen  = sessionStorage.getItem(STORAGE_KEY) === '1';

  // ── Filter drawer ──────────────────────────────────────────────────────────
  function setPanel(state) {
    filterOpen = state;
    var p   = document.getElementById('collection-filters-panel');
    var bd  = document.getElementById('collection-filters-backdrop');
    var t   = document.getElementById('collection-filters-toggle');
    var lbl = document.getElementById('collection-filters-toggle-label');
    var icf = document.getElementById('collection-filters-icon-filter');
    var icc = document.getElementById('collection-filters-icon-close');
    if (p)   p.classList.toggle('collection__filters--open', filterOpen);
    if (bd)  bd.classList.toggle('collection__filters-backdrop--open', filterOpen);
    if (t)   t.setAttribute('aria-expanded', String(filterOpen));
    if (lbl) lbl.textContent = filterOpen ? 'Hide Filters' : 'Show Filters';
    if (icf) icf.style.display = filterOpen ? 'none' : '';
    if (icc) icc.style.display = filterOpen ? '' : 'none';
    document.documentElement.classList.toggle('no-scroll', filterOpen);
    sessionStorage.setItem(STORAGE_KEY, filterOpen ? '1' : '0');
  }

  function setOptionHeights() {
    document.querySelectorAll('.collection__filter--options').forEach(function (el) {
      if (!el.classList.contains('collection__filter--options--collapsed')) {
        el.style.setProperty('--filter-options-height', el.scrollHeight + 'px');
      }
    });
  }

  function initPanelEvents() {
    var t = document.getElementById('collection-filters-toggle');
    if (t && !t.dataset.filtersInit) {
      t.dataset.filtersInit = '1';
      t.addEventListener('click', function () { setPanel(!filterOpen); });
    }
    var c = document.getElementById('collection-filters-close');
    if (c && !c.dataset.filtersInit) {
      c.dataset.filtersInit = '1';
      c.addEventListener('click', function () { setPanel(false); });
    }
    var a = document.getElementById('collection-filters-apply');
    if (a && !a.dataset.filtersInit) {
      a.dataset.filtersInit = '1';
      a.addEventListener('click', function () { setPanel(false); });
    }
    var bd = document.getElementById('collection-filters-backdrop');
    if (bd && !bd.dataset.filtersInit) {
      bd.dataset.filtersInit = '1';
      bd.addEventListener('click', function () { setPanel(false); });
    }
    document.querySelectorAll('[data-filter-toggle]').forEach(function (title) {
      if (!title.dataset.filterInit) {
        title.dataset.filterInit = '1';
        title.addEventListener('click', function () {
          var opts = title.nextElementSibling;
          if (!opts) return;
          var collapsed = opts.classList.toggle('collection__filter--options--collapsed');
          var minus = title.querySelector('[data-filter-icon-minus]');
          var plus  = title.querySelector('[data-filter-icon-plus]');
          if (minus) minus.style.display = collapsed ? 'none' : '';
          if (plus)  plus.style.display  = collapsed ? '' : 'none';
        });
      }
    });
    setOptionHeights();
  }

  if (filterOpen) setPanel(true);
  initPanelEvents();

  // ── Mobile horizontal-scroller scrollbars (product media, shop-by-collection) ──
  function updateMediaScrollbar(scrollEl) {
    var bar = scrollEl.nextElementSibling;
    if (!bar || !bar.hasAttribute('data-media-scrollbar')) return;
    var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
    var progress = maxScroll > 0 ? scrollEl.scrollLeft / maxScroll : 0;
    bar.style.setProperty('--scroll-progress', progress);
    bar.style.setProperty('--thumb-width', (scrollEl.clientWidth / scrollEl.scrollWidth * 100) + '%');
  }

  function initMediaScrollers(root) {
    (root || document).querySelectorAll('[data-media-scroll]').forEach(function (scrollEl) {
      if (!scrollEl.dataset.mediaScrollInit) {
        scrollEl.dataset.mediaScrollInit = '1';
        scrollEl.addEventListener('scroll', function () { updateMediaScrollbar(scrollEl); }, { passive: true });
      }
      updateMediaScrollbar(scrollEl);
    });
  }

  initMediaScrollers();
  window.addEventListener('resize', function () { initMediaScrollers(); });

  // ── Toast ──────────────────────────────────────────────────────────────────
  var toastTimer;
  function showToast(msg, isError) {
    var toastEl = document.getElementById('toast');
    if (!toastEl) return;
    var content = toastEl.querySelector('.toast__content');
    if (content) content.innerHTML = msg;
    toastEl.classList.remove('toast--show', 'toast--error');
    toastEl.classList.add('toast--show');
    if (isError) toastEl.classList.add('toast--error');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('toast--show', 'toast--error'); }, 3000);
  }

  // ── Cart helpers ────────────────────────────────────────────────────────────
  function ajaxAdd(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (res) { return res.json(); });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cart-updated', {
          detail: { items: cart.items, count: cart.item_count }
        }));
      });
  }

  // ── AJAX filters ─────────────────────────────────────────────────────────
    function applyFilter(url) {
    var main = document.getElementById('collection-main');
    if (!main) { window.location.href = url; return; }
    main.classList.add('collection-main--loading');

    var openFilterIndexes = [];
    main.querySelectorAll('.collection__filter--options').forEach(function (el, i) {
      if (!el.classList.contains('collection__filter--options--collapsed')) openFilterIndexes.push(i);
    });

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc     = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.getElementById('collection-main');
        if (!newMain) { window.location.href = url; return; }
        var wasOpen = filterOpen;
        if (wasOpen) {
          var newPanel = newMain.querySelector('#collection-filters-panel');
          if (newPanel) newPanel.classList.add('collection__filters--open');
          var newBackdrop = newMain.querySelector('#collection-filters-backdrop');
          if (newBackdrop) newBackdrop.classList.add('collection__filters-backdrop--open');
        }
        var newOptions = newMain.querySelectorAll('.collection__filter--options');
        openFilterIndexes.forEach(function (i) {
          var opts = newOptions[i];
          if (!opts) return;
          opts.classList.remove('collection__filter--options--collapsed');
          var title = opts.previousElementSibling;
          if (title) {
            var minus = title.querySelector('[data-filter-icon-minus]');
            var plus  = title.querySelector('[data-filter-icon-plus]');
            if (minus) minus.style.display = '';
            if (plus)  plus.style.display  = 'none';
          }
        });
        main.innerHTML = newMain.innerHTML;
        main.classList.remove('collection-main--loading');
        filterOpen = wasOpen;
        initPanelEvents();
        initMediaScrollers();
        window.history.pushState(null, '', url);
      })
      .catch(function () {
        main.classList.remove('collection-main--loading');
        window.location.href = url;
      });
  }

  window.collectionFilterChange = function (checkbox) {
    var url = checkbox.checked ? checkbox.dataset.filterUrl : checkbox.dataset.filterUrlRemove;
    if (url) applyFilter(url);
  };

  window.collectionSortChange = function (select) {
    if (!select.value) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    applyFilter(url.toString());
  };

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.collection__active-filter, .collection__active-filters-clear, a.collection__filters--clear');
    if (link && link.href) { e.preventDefault(); applyFilter(link.href); }
  });

  // ── Add to cart (single-variant card form submit) ─────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.collection__product form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn       = form.querySelector('[name="add"]');
    var variantEl = form.querySelector('input[name="id"]');
    if (!variantEl) return;

    if (btn) {
      btn.disabled = true;
      btn.classList.remove('product-add--ready');
      btn.classList.add('product-add--loading');
    }

    ajaxAdd(variantEl.value)
      .then(function (data) {
        if (data.items) {
          if (btn) {
            btn.classList.remove('product-add--loading');
            btn.classList.add('product-add--added');
            setTimeout(function () {
              btn.classList.remove('product-add--added');
              btn.classList.add('product-add--ready');
              btn.disabled = false;
            }, 2000);
          }
          var title = (data.items[0] && data.items[0].product_title) || '';
          showToast('<b>' + title + '</b> added to cart');
          refreshCart();
        } else {
          showToast(data.description || 'Error adding to cart', true);
          if (btn) {
            btn.classList.remove('product-add--loading');
            btn.classList.add('product-add--ready');
            btn.disabled = false;
          }
        }
      })
      .catch(function () {
        showToast('Error adding to cart', true);
        if (btn) {
          btn.classList.remove('product-add--loading');
          btn.classList.add('product-add--ready');
          btn.disabled = false;
        }
      });
  });

  // ── Quick-buy popup (multi-variant cards) ─────────────────────────────────
  // Vanilla port of src/js/components/Collection/quickBuy.ts
  var QB_MODAL_ID = 'quick-buy-modal';
  var qbProduct = null;

  function qbEscape(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function qbInitialLabel(product) {
    var sizeOpt = product.options.find(function (o) { return o.name === 'Size'; });
    if (sizeOpt) return 'Select ' + sizeOpt.name;
    var first = product.options[0];
    return first ? 'Select ' + first.name : 'Add to Cart';
  }

  function qbReadSelected(slot, options) {
    return options.map(function (option) {
      var checked = slot.querySelector('input[name="qb-option-' + option.position + '"]:checked');
      return checked ? checked.value : null;
    });
  }

  function qbVariantForValue(variants, option, value) {
    var key = 'option' + option.position;
    return variants.find(function (v) { return v[key] === value; });
  }

  function qbFindVariant(variants, options, selected) {
    return variants.find(function (v) {
      return options.every(function (option, idx) { return selected[idx] === v['option' + option.position]; });
    });
  }

  function qbCombinationAvailable(variants, options, selected, changedIndex, candidate) {
    var probe = selected.slice();
    probe[changedIndex] = candidate;
    return variants.some(function (v) {
      return options.every(function (option, idx) {
        if (probe[idx] === null) return true;
        return probe[idx] === v['option' + option.position];
      }) && v.available;
    });
  }

  function qbBuildTint(option, product) {
    var items = option.values.map(function (value, idx) {
      var variant = qbVariantForValue(product.variants, option, value.value);
      if (variant && variant.metafields && variant.metafields.disable_variant) return '';
      var inputId = 'qb-' + product.handle + '-' + option.position + '-' + idx;
      var safe = qbEscape(value.value);
      return '<input type="radio" id="' + inputId + '" name="qb-option-' + option.position + '" value="' + safe + '">'
        + '<label for="' + inputId + '" class="product-form__input--swatches-swatch" style="background-color: '
        + qbEscape(value.swatch_color || '#ccc') + ';" title="' + safe + '"></label>';
    }).join('');
    return '<div class="product-form__input product-form__input--swatches product-form__input--swatches-color">'
      + '<label class="quick-buy__option-label">Select ' + qbEscape(option.name) + ':</label>'
      + '<div class="product-form__input--swatches-wrapper">' + items + '</div></div>';
  }

  function qbBuildBox(option, product) {
    var items = option.values.map(function (value, idx) {
      var variant = qbVariantForValue(product.variants, option, value.value);
      if (variant && variant.metafields && variant.metafields.disable_variant) return '';
      var inputId = 'qb-' + product.handle + '-' + option.position + '-' + idx;
      var safe = qbEscape(value.value);
      var price = variant && variant.price ? qbEscape(variant.price) : '';
      var sticker = variant && variant.metafields ? variant.metafields.variant_sticker : '';
      var highlighted = (variant && variant.metafields && variant.metafields.highlighted_variant)
        ? ' product-form__input--swatches-box--highlighted' : '';
      return '<input type="radio" id="' + inputId + '" name="qb-option-' + option.position + '" value="' + safe + '">'
        + '<label for="' + inputId + '" class="product-form__input--swatches-box' + highlighted + '">'
        + (sticker ? '<span class="variant-sticker">' + qbEscape(sticker) + '</span>' : '')
        + '<span class="variant-value">' + safe + '</span>'
        + (price ? '<span class="variant-price">' + price + '</span>' : '')
        + '</label>';
    }).join('');
    return '<div class="product-form__input product-form__input--swatches product-form__input--swatches-generic">'
      + '<label class="quick-buy__option-label">Select ' + qbEscape(option.name) + ':</label>'
      + '<div class="product-form__input--swatches-wrapper">' + items + '</div></div>';
  }

  function qbBuildOption(option, product) {
    return option.name === 'Tint' ? qbBuildTint(option, product) : qbBuildBox(option, product);
  }

  function qbRefreshDisabled(slot, product) {
    var selected = qbReadSelected(slot, product.options);
    product.options.forEach(function (option, idx) {
      slot.querySelectorAll('input[name="qb-option-' + option.position + '"]').forEach(function (input) {
        var ok = qbCombinationAvailable(product.variants, product.options, selected, idx, input.value);
        input.classList.toggle('disabled', !ok);
      });
    });
  }

  function qbRefreshButton(slot, product) {
    var selected = qbReadSelected(slot, product.options);
    var allSelected = selected.every(function (s) { return s !== null; });
    var variant = allSelected ? qbFindVariant(product.variants, product.options, selected) : undefined;
    var button = slot.querySelector('.quick-buy__add-to-cart');
    if (button && !button.dataset.busy) {
      var canAdd = !!variant && variant.available;
      button.disabled = !canAdd;
      button.textContent = canAdd ? 'Add to Cart' : qbInitialLabel(product);
    }
    return variant;
  }

  function qbClearHighlighted(slot) {
    slot.querySelectorAll('.product-form__input--swatches-box--highlighted').forEach(function (el) {
      el.classList.remove('product-form__input--swatches-box--highlighted');
    });
  }

  function showQbModal() {
    var m = document.getElementById(QB_MODAL_ID);
    if (!m) return;
    m.classList.remove('hide-modal');
    document.documentElement.classList.add('no-scroll');
  }

  function hideQbModal() {
    var m = document.getElementById(QB_MODAL_ID);
    if (!m) return;
    m.classList.add('hide-modal');
    if (!filterOpen) document.documentElement.classList.remove('no-scroll');
  }

  function openQuickBuy(product) {
    var modal = document.getElementById(QB_MODAL_ID);
    if (!modal) return;
    var slot = modal.querySelector('.quick-buy__content');
    if (!slot) return;

    qbProduct = product;
    var byline = (product.metafields && product.metafields.byline)
      ? '<p class="quick-buy__byline">' + qbEscape(product.metafields.byline) + '</p>' : '';
    var sections = product.options.map(function (option) { return qbBuildOption(option, product); }).join('');

    slot.innerHTML =
      '<h2 class="quick-buy__title">' + qbEscape(product.title) + '</h2>' +
      byline + sections +
      '<button type="button" class="quick-buy__add-to-cart" disabled>' + qbEscape(qbInitialLabel(product)) + '</button>';

    qbRefreshDisabled(slot, product);
    qbRefreshButton(slot, product);
    showQbModal();
  }

  // Quick-buy delegated events (bound once; modal markup persists across AJAX)
  (function bindQuickBuy() {
    var modal = document.getElementById(QB_MODAL_ID);
    if (!modal) return;
    var slot = modal.querySelector('.quick-buy__content');
    if (!slot) return;

    slot.addEventListener('change', function (e) {
      if (!qbProduct) return;
      var target = e.target;
      if (target.tagName !== 'INPUT' || target.type !== 'radio') return;
      qbClearHighlighted(slot);
      qbRefreshDisabled(slot, qbProduct);
      qbRefreshButton(slot, qbProduct);
    });

    slot.addEventListener('click', function (e) {
      var button = e.target.closest('.quick-buy__add-to-cart');
      if (!button || !qbProduct) return;
      var variant = qbRefreshButton(slot, qbProduct);
      if (!variant || !variant.available || button.dataset.busy) return;

      button.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Adding…';

      var title = qbProduct.title;
      ajaxAdd(variant.id)
        .then(function (data) {
          if (data.items) {
            hideQbModal();
            showToast('<b>' + qbEscape(title) + '</b> added to cart');
            refreshCart();
          } else {
            showToast(data.description || 'Could not add to cart', true);
          }
        })
        .catch(function () { showToast('Could not add to cart', true); })
        .then(function () {
          delete button.dataset.busy;
          qbRefreshButton(slot, qbProduct);
        });
    });
  })();

  // ── Inline variant selection on cards (single-option products) ────────────
  // Swatches/sizes rendered as buttons with data-card-variant switch the card's
  // price and add-to-cart button to that variant, so no quick-buy popup is needed.
  function selectCardVariant(option) {
    var card = option.closest('.collection__product');
    if (!card) return;

    var group = option.parentElement;
    group.querySelectorAll('[data-card-variant]').forEach(function (el) {
      var selected = el === option;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var variantId = option.dataset.cardVariant;
    var available = option.dataset.variantAvailable === 'true';
    var price = option.dataset.variantPrice;
    var compare = option.dataset.variantCompare;

    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) {
      priceEl.innerHTML = compare
        ? '<span class="collection__product-price--sale">' + price + '</span> <span class="collection__product-price--compare">' + compare + '</span>'
        : price;
    }

    var button = card.querySelector('add-to-cart-button');
    if (button) {
      button.dataset.productVariantId = variantId;
      button.dataset.productVariantPrice = option.dataset.variantPriceCents;
      // The component checks its own `disabled` property, so set both
      button.disabled = !available;
      if (available) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
      var label = available ? button.dataset.addToCartLabel : button.dataset.soldOutLabel;
      button.setAttribute('aria-label', label);
      var text = button.querySelector('.product-add__text');
      if (text && !button.dataset.defaultText) button.dataset.defaultText = text.textContent;
      if (text) text.textContent = available ? button.dataset.defaultText : button.dataset.soldOutLabel;
    }

    // Show the variant's own image, if it has one (desktop image + first slide of the mobile scroller)
    var image = option.dataset.variantImage;
    if (image) {
      var primary = card.querySelector('.responsive-image__image--primary');
      if (primary) primary.src = image;
      // Keep the new image visible while the cursor stays on the swatches/details (the hover
      // image would otherwise cover it). Moving onto the image, or off the card, brings the
      // hover image back as normal.
      card.classList.add('collection__product--variant-image');
      var imageLink = card.querySelector('.collection__product-image');
      var restoreHover = function () {
        card.classList.remove('collection__product--variant-image');
        card.removeEventListener('mouseleave', restoreHover);
        if (imageLink) imageLink.removeEventListener('mouseenter', restoreHover);
      };
      card.addEventListener('mouseleave', restoreHover);
      if (imageLink) imageLink.addEventListener('mouseenter', restoreHover);
      var firstSlide = card.querySelector('.product-card__media-image');
      if (firstSlide) {
        firstSlide.src = image;
        var scroller = firstSlide.closest('[data-media-scroll]');
        if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }

    // Keep the image/title links pointing at the chosen variant
    card.querySelectorAll('a.collection__product-image, a.collection__product-title').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.pathname + url.search;
    });
  }

  document.addEventListener('click', function (e) {
    var option = e.target.closest('[data-card-variant]');
    if (!option) return;
    e.preventDefault();
    selectCardVariant(option);
  });

  // ── Whole card clicks through to the PDP ───────────────────────────────────
  // The image, title and size links already do; this covers the white space.
  // Uses the title link's href, which tracks the selected variant.
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.main-collection .collection__product');
    if (!card) return;
    // Leave real controls (links, swatches, add to cart, quick-add) to do their own thing
    if (e.target.closest('a, button, add-to-cart-button, input, select, label, [role="button"], [data-quick-buy]')) return;
    // Don't navigate when the user is selecting text
    var selection = window.getSelection && window.getSelection().toString();
    if (selection) return;

    var link = card.querySelector('a.collection__product-title');
    if (!link || !link.href) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  });

  // Open the popup from a card's quick-add button
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-buy]');
    if (!trigger) return;
    e.preventDefault();
    var card = trigger.closest('.collection__product');
    if (!card) return;
    var dataEl = card.querySelector('.collection__product-data');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    openQuickBuy(product);
  });

  // Close the popup
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-close="' + QB_MODAL_ID + '"]')) hideQbModal();
    var modal = document.getElementById(QB_MODAL_ID);
    if (modal && e.target === modal) hideQbModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideQbModal();
  });

  // ── Sticky filters bar on mobile ──────────────────────────────────────────
  (function () {
    var MOBILE_BP = 769;
    var HEADER_H  = 94; // px — stuck header (64px) + announcement bar (30px)

    function initStickyBar() {
      var bar = document.querySelector('.collection__filters-bar');
      if (!bar) return;

      if (window.innerWidth >= MOBILE_BP) return;

      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'height:0;pointer-events:none;';
      bar.parentNode.insertBefore(sentinel, bar);

      var isFixed = false;
      var barW, barTop;

      function measure() {
        isFixed = false;
        bar.style.cssText = '';
        sentinel.style.marginBottom = '';
        barTop = sentinel.getBoundingClientRect().top + window.pageYOffset;
        barW   = bar.offsetWidth;
      }

      function onScroll() {
        if (window.innerWidth >= MOBILE_BP) {
          if (isFixed) { bar.style.cssText = ''; sentinel.style.marginBottom = ''; isFixed = false; }
          return;
        }
        var shouldFix = window.pageYOffset + HEADER_H >= barTop;
        if (shouldFix && !isFixed) {
          isFixed = true;
          bar.style.cssText = 'position:fixed;top:' + HEADER_H + 'px;left:0;right:0;width:100%;z-index:90;background:white;padding-left:15px;padding-right:15px;padding-top:15px;box-sizing:border-box;border-top:1px solid #eaeaea;border-bottom:1px solid #eaeaea;';
          sentinel.style.marginBottom = bar.offsetHeight + 'px';
        } else if (!shouldFix && isFixed) {
          isFixed = false;
          bar.style.cssText = '';
          sentinel.style.marginBottom = '';
        }
      }

      measure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyBar);
    } else {
      initStickyBar();
    }
  })();
})();
